<p-dialog
  header="{{ 'Todo.Common.PleaseEnterPassword' | translate }}"
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  closeIcon="pi pi-close"
  styleClass="p-dialog-sm"
  appendTo="body"
  (onHide)="closeDialog()"
>
  <div class="p-field">
    <input
      id="password"
      type="password"
      pInputText
      [(ngModel)]="enteredPassword"
      style="width: 100%;"
    />
  </div>
  <div *ngIf="warningMessage" class="error-message">
      {{ warningMessage }}
  </div>
  <div class="p-d-flex p-jc-center" style="margin-top: 15px;">
    <button
      pButton
      label="{{ 'Common.Button.Submit' | translate }}"
      class="p-button-primary"
      (click)="submitPassword()"
    ></button>
  </div>
</p-dialog>